module.exports = __webpack_public_path__ + "img/energy_gray.2b3264e9.svg";